/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Button } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from '@reach/router';
import DialogContent from '@material-ui/core/DialogContent';
import DrawerPwa from '../../components/DrawerPwa';
import DialogBox from '../../components/DialogBox';
// import { Badge } from '../../components/Icons';
import css from './index.module.scss';
const ErrorOfferPopUp = ({ offerError, setErrorPopup, isDesktop }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // eslint:fix
  const dismissPopup = () => {
    setErrorPopup(false);
  };
  const goTocart = () => {
    navigate(`/${intl.locale}/cart`, { replace: true });
  };
  const renderInnerPopUp = () => {
    return (
      <DialogContent dividers={true}>
        <div className={css.reviewCart}>
          <div className={css.heading}>
            <FormattedMessage id="offerNotApplicable" defaultMessage="Coupon Not Applicable" />
          </div>

          <p>
            {offerError !== '' ? (
              offerError
            ) : (
              <FormattedMessage
                id="offerErrorPopup"
                defaultMessage="You have made all the redemptions for the coupon. Please review your cart"
              />
            )}
          </p>
          <div className={css.buttons}>
            <Button onClick={dismissPopup} variant="outlined" color="primary" className={css.close}>
              <FormattedMessage id="cartDismiss" defaultMessage="Dismiss" />
            </Button>
            <Button variant="contained" color="primary" onClick={goTocart} className={css.submit}>
              <FormattedMessage id="checkout_reviewcart" defaultMessage="Review Cart" />
            </Button>
          </div>
        </div>
      </DialogContent>
    );
  };
  return (
    <React.Fragment>
      {!isDesktop ? (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={true}
          className={css.nobg}
          onClose={dismissPopup}
        >
          {renderInnerPopUp()}
        </DrawerPwa>
      ) : (
        <DialogBox size="sm" isOpen={true} onClose={dismissPopup}>
          {renderInnerPopUp()}
        </DialogBox>
      )}
    </React.Fragment>
  );
};

export default ErrorOfferPopUp;
